import classNames from 'classnames';
import Button from '../../shared/Button';
import Link from '../../shared/Link';
import Typografed from '../../shared/Typografed';

export type CtaSectionProps = {
    title: string;
    subtitle: string;
    note: string;
    link?: {
        name: string;
        href: string;
    } | null;
};

type Props = React.HTMLAttributes<HTMLElement> & {
    ctaSectionProps: CtaSectionProps;
};

const CTA_LINKS = [
    {
        title: 'FORUM',
        description: 'Деловая программа, экспертные сессии и нетворкинг с лидерами отрасли',
        href: '/participation/participants/',
    },
    {
        title: 'EXPO',
        description: 'Территория знаний и решений для бизнеса',
        href: '/participation/visitors/',
    },
];

const CtaSection = ({ ctaSectionProps, ...props }: Props) => {
    return (
        <section
            {...props}
            className={classNames('cta-section js-header-theme-trigger', props.className)}
            data-theme="light"
        >
            <div className="cta-section__wrapper wrapper">
                <h2 className="cta-section__title">
                    <Typografed>{ctaSectionProps.title}</Typografed>
                </h2>
                {ctaSectionProps.subtitle && (
                    <p className="cta-section__subtitle text-l">
                        <Typografed>{ctaSectionProps.subtitle}</Typografed>
                    </p>
                )}
                <div className="cta-section__links">
                    {CTA_LINKS.map((item) => (
                        <div className="cta-section__link" key={item.title}>
                            <div className="cta-section__link-inner">
                                <h3 className="cta-section__link-title h2">{item.title}</h3>
                                <p className="cta-section__link-description text-m">
                                    <Typografed>{item.description}</Typografed>
                                </p>

                                <Button
                                    tag={Link}
                                    href={item.href}
                                    className="cta-section__link-button text-xs"
                                    variant="outline-light"
                                    aria-label={`Перейти на ${item.title}`}
                                >
                                    Перейти
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
                {ctaSectionProps.note && (
                    <p className="cta-section__note text-m">
                        <Typografed>{ctaSectionProps.note}</Typografed>
                    </p>
                )}
            </div>
        </section>
    );
};

export default CtaSection;
